import firebaseApp from 'firebase/app'
import store from '../vuex/store'

export default {
  checkAuth (to, from, next) {
    firebaseApp.auth().onAuthStateChanged(user => {
      if (!user) next({ name: 'Login' })
      else {
        store.dispatch('login').then(res => {
          const user = store.getters.getCurrentUser
          if (user && !user.firebaseAccount.selectedAdvertiser) {
            next({ name: 'Welcome' })
          } else next()
        })
      }
    })
  },
  checkAuthWithoutSelectedAdvertiser (to, from, next) {
    firebaseApp.auth().onAuthStateChanged(user => {
      if (!user) next({ name: 'Login' })
      else next()
    })
  },
  redirectToHome (to, from, next) {
    firebaseApp.auth().onAuthStateChanged(user => {
      const storage = JSON.parse(localStorage.getItem('outfoxUser'))
      if (user && storage) {
        store.dispatch('login')
        next({ name: 'Home' })
      } else next()
    })
  },
  checkSelectedAdvertiser (to, from, next) {
    const user = store.getters.getCurrentUser
    if (user && user.firebaseAccount.selectedAdvertiser) {
      next({ name: 'Home' })
    }
    next()
  }
}
